export const PATH_BUY = '/buy/*';
export const PATH_BUY_SIGNUP = '/buy/signup';
export const PATH_BUY_LOGIN = '/buy/login';
export const PATH_BUY_ADD = '/buy/add/:productId';
export const PATH_BUY_THANK_YOU = '/buy/thank-you/:token';
